import { CreateMetricResponse, UpdateMetricResponse } from 'tabs/data/api/generated'
import {
  CreateDatasetMetricsParams,
  createTableMetric,
  UpdateDatasetMetricParams,
  updateTableMetric,
} from 'tabs/data/api/metrics'

type UseDatasetTablesParams = {
  createMetric: (
    datasetId: string,
    metricId: string,
    params: CreateDatasetMetricsParams,
  ) => Promise<CreateMetricResponse>
  updateMetric: (
    metricId: string,
    datasetId: string,
    tableId: string,
    force: boolean,
    params: UpdateDatasetMetricParams,
  ) => Promise<UpdateMetricResponse>
}

export const useDatasetMetrics = (): UseDatasetTablesParams => {
  const createMetric = async (datasetId: string, metricId: string, params: CreateDatasetMetricsParams) => {
    return createTableMetric(datasetId, metricId, params)
  }

  const updateMetric = async (
    metricId: string,
    datasetId: string,
    tableId: string,
    force: boolean,
    params: UpdateDatasetMetricParams,
  ) => {
    return updateTableMetric(metricId, datasetId, tableId, force, params)
  }

  return { createMetric, updateMetric }
}
